import React from "react"
import DeleteFilter from "../../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../../config/api";
import axios from "axios";
import { number_format } from "../../../../../config/Helpers";

const postUrlLogin  = API_URL + "widgets";

class PacePickup extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            result_rows : (<div></div>),
            total_widgets : { 
                room_nights_by_widget_ly     : 0, 
                room_nights_by_widget  : 0, 
                room_nights_budget_by_widget : 0,
                room_nights_bb_by_widget     : 0 
            },
            totals_general : 0,
        }
    }
    activeWdg(type){
        this.props.activeWidget(type)
    }
    getRow(wdg_aux, filt, index, title = true){
        return filt !== "totals" ? 
        <div key={"list-pace-pickup-"+index} className={ index%2 ? "row-c" : "" }>
            <div>{ number_format(wdg_aux[filt].room_night_pace_ly, 2) }%</div>
            <div>{ number_format(wdg_aux[filt].room_night_pace, 2) }%</div>
        </div>
    :   <div key={"list-pace-pickup-"+index} className={"datagrid-month " + (title === true ? "totals" : (index%2 ? "row-c" : ""))}>
            <div>{ number_format(wdg_aux[filt].room_night_pace_ly_widget, 2) }%</div>
            <div>{ number_format(wdg_aux[filt].room_night_pace_widget, 2) }%</div>
        </div>
    }
    componentWillReceiveProps(props){
        const
            has_statics_channels  = (Object.keys(this.props.statics_channels).length > 0),
            has_statics_segments  = (Object.keys(this.props.statics_segments).length > 0),
            has_statics_trimester = (Object.keys(this.props.statics_trimester).length > 0),
            has_statics_time      = (Object.keys(this.props.statics).length > 0),
            has_totals_channels   = (Object.keys(this.props.total_widgets_channels).length > 0)

        let wdg_aux = [], totals_general = "";
        wdg_aux["channels"] = this.props.statics_channels; 
        wdg_aux["segments"] = this.props.statics_segments; 
        wdg_aux["trimester"] = this.props.statics_trimester; 
        wdg_aux["months"] = this.props.statics; 
        
        this.state.totals_general = (<div className={"datagrid-month totals"}>
            <div>{ number_format(this.state.total_widgets.room_night_pace_ly_widget, 2) }%</div>
            <div>{ number_format(this.state.total_widgets.room_night_pace_widget, 2) }%</div>
        </div>);

        if(Object.keys(wdg_aux).length > 0){
            let key_times = this.props.layout.state.segmentActive;
            let key_times_aux = this.props.app._LayoutReview.state.key_time;
            this.state.result_rows = Object.keys(this.props.statics).map((filt, index) => {
                if(has_statics_channels){
                    if((wdg_aux["channels"][filt] !== undefined) && (key_times_aux[filt] !== undefined)){
                        const wdg = wdg_aux["channels"][filt];
                        return Object.keys(wdg).map((filt_aux, index_aux) => {
                            if(filt_aux !== "totals"){
                                //if(wdg[filt_aux].num_reservations !== 0){
                                    let channel_list = wdg[filt_aux];
                                    if(key_times[filt_aux] !== undefined){
                                        return Object.keys(channel_list).map((filt_channel, index_channel) => {
                                            return this.getRow(channel_list, filt_channel, index_aux)
                                        })
                                    }else{
                                        return this.getRow(wdg[filt_aux], "totals", index_aux, false)
                                    }
                                //}
                            }else{
                                return this.getRow(wdg, filt_aux, index_aux)
                            }
                        })
                    }
                }   
                if(has_statics_segments){
                    if((wdg_aux["segments"][filt]['segments'] !== undefined) && (key_times_aux[filt] !== undefined)){
                        const wdg = wdg_aux["segments"][filt]["segments"];
                        return Object.keys(wdg).map((filt_aux, index_aux) => {
                            if(filt_aux === "totals"){
                                return this.getRow(wdg, filt_aux, index_aux)
                            }else{
                                return this.getRow(wdg, filt_aux, index_aux)
                            }
                        })
                    }
                }
                if(has_statics_time){
                    //if(wdg_aux["months"][filt].num_reservations !== 0){
                        return this.getRow(wdg_aux["months"], filt, index)
                    //}
                }
            })
        }
        this.setState({ total_widgets : this.props.total_widgets });
    }
    
    render(){    
        const self = this
        const year = (self.props.app !== undefined) ? self.props.app.state.year_pickup_future : 1;     
        return (
            <div className={"datagrid-widget pacePickup  "+ this.props.hidden_wdg_room_nights}>
                <div className="container-fluid">
                    <div className="row header-widget">
                        <div className="col-md-12 options-widget">
                            <span className="title">PACE</span>
                            { /*<span className="opt remove-widget" onClick={this.activeWdg.bind(this, "room-nights")}>
                                <img src={DeleteFilter} />
                            </span> */ }
                        </div>
                    </div>
                    <div className="current-values">
                        <div className="row">
                            <div className="col-md-12 head-current">
                                <span>{(year - 1)}</span>
                                <span>{year}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 datagrid-list">
                                { this.state.result_rows }
                                { this.state.totals_general }
                            </div>
                        </div>
                    </div>   
                </div>
            </div> 
        )
    }
};

export default PacePickup



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/review/views/Pickup/PacePickup.js